/**
 * 管理后台路由
 */
export default [
    /*
    |--------------------------------------------------------------------------
    | 首页
    |--------------------------------------------------------------------------
    */
    {
        path: '/',
        name: 'index',
        meta: {

            title: '控制台'
        },
        component: () => import('@/views/home/Index.vue')
    },
    {
        path: '/profile',
        name: 'profile',
        meta: {

            title: '个人信息'
        },
        component: () => import('@/views/home/Profile.vue')
    },



    /*
    |--------------------------------------------------------------------------
    | 订单管理
    |--------------------------------------------------------------------------
    */
    {
        path: '/order',
        name: 'order',
        meta: {

            title: '全部订单'
        },
        component: () => import('@/views/order/Index.vue')
    },
    {
        path: '/order/pending/:status',
        name: 'order-pending',
        meta: {

            title: '待支付订单'
        },
        component: () => import('@/views/order/Index.vue')
    },
    {
        path: '/order/paid/:status',
        name: 'order-paid',
        meta: {

            title: '待发货订单'
        },
        component: () => import('@/views/order/Index.vue')
    },
    {
        path: '/order/delivered/:status',
        name: 'order-delivered',
        meta: {

            title: '待收货订单'
        },
        component: () => import('@/views/order/Index.vue')
    },
    {
        path: '/order/received/:status',
        name: 'order-received',
        meta: {

            title: '待评价订单'
        },
        component: () => import('@/views/order/Index.vue')
    },
    {
        path: '/order/completed/:status',
        name: 'order-completed',
        meta: {

            title: '已完成订单'
        },
        component: () => import('@/views/order/Index.vue')
    },
    {
        path: '/order/cancel/:status',
        name: 'order-cancel',
        meta: {

            title: '已取消订单'
        },
        component: () => import('@/views/order/Index.vue')
    },
    {
        path: '/order/qianshou/:status',
        name: 'order-qianshou',
        meta: {

            title: '已签收订单'
        },
        component: () => import('@/views/order/Index.vue')
    },
    /*
   |--------------------------------------------------------------------------
   | 订单售后管理
   |--------------------------------------------------------------------------
   */
    {
        path: '/order-after-sales',
        name: 'order-after-sales',
        meta: {

            title: '订单售后管理'
        },
        component: () => import('@/views/order-after-sales/Index.vue')
    },
    {
        path: '/order-after-sales/update/:id',
        name: 'order-after-sales-update',
        meta: {

            title: '订单售后详情'
        },
        component: () => import('@/views/order-after-sales/Form.vue')
    },
    /*
    |--------------------------------------------------------------------------
    | 积分兑换管理
    |--------------------------------------------------------------------------
    */
    {
        path: '/credit-exchange',
        name: 'credit-exchange',
        meta: {

            title: '全部兑换'
        },
        component: () => import('@/views/credit-exchange/Index.vue')
    },
    {
        path: '/credit-exchange/pending/:status',
        name: 'credit-exchange-pending',
        meta: {

            title: '待支付'
        },
        component: () => import('@/views/credit-exchange/Index.vue')
    },
    {
        path: '/credit-exchange/paid/:status',
        name: 'credit-exchange-paid',
        meta: {

            title: '待发货'
        },
        component: () => import('@/views/credit-exchange/Index.vue')
    },
    {
        path: '/credit-exchange/delivered/:status',
        name: 'credit-exchange-delivered',
        meta: {

            title: '已发货'
        },
        component: () => import('@/views/credit-exchange/Index.vue')
    },
    {
        path: '/credit-exchange/completed/:status',
        name: 'credit-exchange-completed',
        meta: {

            title: '已完成'
        },
        component: () => import('@/views/credit-exchange/Index.vue')
    },
    {
        path: '/credit-exchange/cancel/:status',
        name: 'credit-exchange-cancel',
        meta: {

            title: '已取消'
        },
        component: () => import('@/views/credit-exchange/Index.vue')
    },

    /*
    |--------------------------------------------------------------------------
    | 赚积分管理
    |--------------------------------------------------------------------------
    */
    {
        path: '/credit-get-path',
        name: 'credit-get-path',
        meta: {

            title: '赚积分管理'
        },
        component: () => import('@/views/credit-get-path/Index.vue')
    },
    {
        path: '/credit-get-path/create',
        name: 'credit-get-path-create',
        meta: {

            title: '添加路径'
        },
        component: () => import('@/views/credit-get-path/Form.vue')
    },
    {
        path: '/credit-get-path/update/:id',
        name: 'credit-get-path-update',
        meta: {

            title: '修改路径'
        },
        component: () => import('@/views/credit-get-path/Form.vue')
    },

    /*
    |--------------------------------------------------------------------------
    | 分享有礼
    |--------------------------------------------------------------------------
    */
    {
        path: '/invite-exchange',
        name: 'invite-exchange',
        meta: {

            title: '全部兑换'
        },
        component: () => import('@/views/invite-exchange/Index.vue')
    },
    {
        path: '/invite-exchange/pending/:status',
        name: 'invite-exchange-pending',
        meta: {

            title: '待发货兑换'
        },
        component: () => import('@/views/invite-exchange/Index.vue')
    },
    {
        path: '/invite-exchange/completed/:status',
        name: 'invite-exchange-completed',
        meta: {

            title: '已完成兑换'
        },
        component: () => import('@/views/invite-exchange/Index.vue')
    },

    /*
    |--------------------------------------------------------------------------
    | 邀请记录
    |--------------------------------------------------------------------------
    */
    {
        path: '/invite',
        name: 'invite',
        meta: {

            title: '邀请记录'
        },
        component: () => import('@/views/invite/Index.vue')
    },

    /*
    |--------------------------------------------------------------------------
    | 积分礼品管理
    |--------------------------------------------------------------------------
    */
    {
        path: '/credit-gift',
        name: 'credit-gift',
        meta: {

            title: '礼品管理'
        },
        component: () => import('@/views/credit-gift/Index.vue')
    },
    {
        path: '/credit-gift/create',
        name: 'credit-gift-create',
        meta: {

            title: '添加礼品'
        },
        component: () => import('@/views/credit-gift/Form.vue')
    },
    {
        path: '/credit-gift/update/:id',
        name: 'credit-gift-update',
        meta: {

            title: '修改礼品'
        },
        component: () => import('@/views/credit-gift/Form.vue')
    },

    /*
    |--------------------------------------------------------------------------
    | 优惠券管理
    |--------------------------------------------------------------------------
    */
    {
        path: '/coupon',
        name: 'coupon',
        meta: {

            title: '优惠券管理'
        },
        component: () => import('@/views/coupon/Index.vue')
    },
    {
        path: '/coupon/create',
        name: 'coupon-create',
        meta: {

            title: '添加优惠券'
        },
        component: () => import('@/views/coupon/Form.vue')
    },
    {
        path: '/coupon/update/:id',
        name: 'coupon-update',
        meta: {

            title: '修改优惠券'
        },
        component: () => import('@/views/coupon/Form.vue')
    },

    /*
    |--------------------------------------------------------------------------
    | 抽奖活动
    |--------------------------------------------------------------------------
    */
    {
        path: '/prize-draw',
        name: 'prize-draw',
        meta: {

            title: '抽奖管理'
        },
        component: () => import('@/views/prize-draw/Index.vue')
    },
    {
        path: '/prize-draw/create',
        name: 'prize-draw-create',
        meta: {

            title: '添加抽奖'
        },
        component: () => import('@/views/prize-draw/Form.vue')
    },
    {
        path: '/prize-draw/update/:id',
        name: 'prize-draw-update',
        meta: {

            title: '修改抽奖'
        },
        component: () => import('@/views/prize-draw/Form.vue')
    },
    {
        path: '/prize-draw/records/:id',
        name: 'prize-draw-records',
        meta: {

            title: '抽奖记录'
        },
        component: () => import('@/views/prize-draw/Records.vue')
    },

    /*
    |--------------------------------------------------------------------------
    | 商品促销
    |--------------------------------------------------------------------------
    */
    {
        path: '/promotion',
        name: 'promotion',
        meta: {

            title: '促销管理'
        },
        component: () => import('@/views/promotion/Index.vue')
    },
    {
        path: '/promotion/create',
        name: 'promotion-create',
        meta: {

            title: '添加促销'
        },
        component: () => import('@/views/promotion/Form.vue')
    },
    {
        path: '/promotion/update/:id',
        name: 'promotion-update',
        meta: {

            title: '修改促销'
        },
        component: () => import('@/views/promotion/Form.vue')
    },

    /*
    |--------------------------------------------------------------------------
    | 商品特价
    |--------------------------------------------------------------------------
    */
    {
        path: '/on-sales',
        name: 'on-sales',
        meta: {

            title: '特价管理'
        },
        component: () => import('@/views/on-sales/Index.vue')
    },
    {
        path: '/on-sales/create',
        name: 'on-sales-create',
        meta: {

            title: '添加特价'
        },
        component: () => import('@/views/on-sales/Form.vue')
    },
    {
        path: '/on-sales/update/:id',
        name: 'on-sales-update',
        meta: {

            title: '修改特价'
        },
        component: () => import('@/views/on-sales/Form.vue')
    },

    /*
    |--------------------------------------------------------------------------
    | 商品秒杀
    |--------------------------------------------------------------------------
    */
    {
        path: '/seckill',
        name: 'seckill',
        meta: {

            title: '秒杀管理'
        },
        component: () => import('@/views/seckill/Index.vue')
    },
    {
        path: '/seckill/create',
        name: 'seckill-create',
        meta: {

            title: '添加秒杀'
        },
        component: () => import('@/views/seckill/Form.vue')
    },
    {
        path: '/seckill/update/:id',
        name: 'seckill-update',
        meta: {

            title: '修改秒杀'
        },
        component: () => import('@/views/seckill/Form.vue')
    },

    /*
    |--------------------------------------------------------------------------
    | 商品秒杀报名
    |--------------------------------------------------------------------------
    */
    {
        path: '/seckill-apply',
        name: 'seckill-apply',
        meta: {

            title: '秒杀报名'
        },
        component: () => import('@/views/seckill-apply/Index.vue')
    },

    /*
    |--------------------------------------------------------------------------
    | 在拼团单
    |--------------------------------------------------------------------------
    */
    {
        path: '/pintuan-group',
        name: 'pintuan-group',
        meta: {

            title: '在拼团单'
        },
        component: () => import('@/views/pintuan-group/Index.vue')
    },

    /*
    |--------------------------------------------------------------------------
    | 拼团管理
    |--------------------------------------------------------------------------
    */
    {
        path: '/pintuan',
        name: 'pintuan',
        meta: {

            title: '拼团设置'
        },
        component: () => import('@/views/pintuan/Index.vue')
    },
    {
        path: '/pintuan/create',
        name: 'pintuan-create',
        meta: {

            title: '添加拼团'
        },
        component: () => import('@/views/pintuan/Form.vue')
    },
    {
        path: '/pintuan/update/:id',
        name: 'pintuan-update',
        meta: {

            title: '修改拼团'
        },
        component: () => import('@/views/pintuan/Form.vue')
    },

    /*
    |--------------------------------------------------------------------------
    | 商品管理
    |--------------------------------------------------------------------------
    */
    {
        path: '/goods',
        name: 'goods',
        meta: {

            title: '商品管理'
        },
        component: () => import('@/views/goods/Index.vue')
    },
    {
        path: '/goods/create',
        name: 'goods-create',
        meta: {

            title: '添加商品'
        },
        component: () => import('@/views/goods/Form.vue')
    },
    {
        path: '/goods/update/:id',
        name: 'goods-update',
        meta: {

            title: '修改商品'
        },
        component: () => import('@/views/goods/Form.vue')
    },

    /*
    |--------------------------------------------------------------------------
    | 商品评价
    |--------------------------------------------------------------------------
    */
    {
        path: '/goods-comment',
        name: 'goods-comment',
        meta: {

            title: '商品评价'
        },
        component: () => import('@/views/goods-comment/Index.vue')
    },

    /*
    |--------------------------------------------------------------------------
    | 属性管理
    |--------------------------------------------------------------------------
    */
    {
        path: '/attr',
        name: 'attr',
        meta: {

            title: '属性管理'
        },
        component: () => import('@/views/attr/Index.vue')
    },
    {
        path: '/attr/create',
        name: 'attr-create',
        meta: {

            title: '添加属性'
        },
        component: () => import('@/views/attr/Form.vue')
    },
    {
        path: '/attr/update/:id',
        name: 'attr-update',
        meta: {

            title: '修改属性'
        },
        component: () => import('@/views/attr/Form.vue')
    },

    /*
    |--------------------------------------------------------------------------
    | 分类管理
    |--------------------------------------------------------------------------
    */
    {
        path: '/category/attr/:type',
        name: 'category-attr',
        meta: {

            title: '属性分类'
        },
        component: () => import('@/views/category/Index.vue')
    },
    {
        path: '/category/goods/:type',
        name: 'category-goods',
        meta: {

            title: '商品分类'
        },
        component: () => import('@/views/category/Index.vue')
    },
    {
        path: '/category/create/:type',
        name: 'category-create',
        meta: {

            title: '添加分类'
        },
        component: () => import('@/views/category/Form.vue')
    },
    {
        path: '/category/update/:id',
        name: 'category-update',
        meta: {

            title: '修改分类'
        },
        component: () => import('@/views/category/Form.vue')
    },

    /*
    |--------------------------------------------------------------------------
    | 平台数据
    |--------------------------------------------------------------------------
    */
    {
        path: '/platform-order-data',
        name: 'platform-order-data',
        meta: {

            title: '平台数据'
        },
        component: () => import('@/views/platform-order-data/Index.vue')
    },
    {
        path: '/platform-order-data/create',
        name: 'platform-order-data-create',
        meta: {

            title: '添加数据'
        },
        component: () => import('@/views/platform-order-data/Form.vue')
    },
    {
        path: '/platform-order-data/update/:id',
        name: 'platform-order-data-update',
        meta: {

            title: '修改数据'
        },
        component: () => import('@/views/platform-order-data/Form.vue')
    },

    /*
    |--------------------------------------------------------------------------
    | 平台数据汇总
    |--------------------------------------------------------------------------
    */
    {
        path: '/platform-order-data-summary',
        name: 'platform-order-data-summary',
        meta: {

            title: '汇总'
        },
        component: () => import('@/views/platform-order-data-summary/Index.vue')
    },
    /*
    |--------------------------------------------------------------------------
    | 平台数据退货汇总
    |--------------------------------------------------------------------------
    */
    {
        path: '/platform-order-data-refund-summary',
        name: 'platform-order-data-refund-summary',
        meta: {

            title: '退货汇总'
        },
        component: () => import('@/views/platform-order-data-refund-summary/Index.vue')
    },
    /*
    |--------------------------------------------------------------------------
    | 用户管理
    |--------------------------------------------------------------------------
    */
    {
        path: '/user',
        name: 'user',
        meta: {

            title: '用户管理'
        },
        component: () => import('@/views/user/Index.vue')
    },
    {
        path: '/user/detail/:id',
        name: 'user-detail',
        meta: {

            title: '用户详情'
        },
        component: () => import('@/views/user/Detail.vue')
    },


    /*
    |--------------------------------------------------------------------------
    | 用户积分记录
    |--------------------------------------------------------------------------
    */
    {
        path: '/user-credit-records',
        name: 'user-credit-records',
        meta: {

            title: '用户积分记录'
        },
        component: () => import('@/views/user-credit-records/Index.vue')
    },

    /*
    |--------------------------------------------------------------------------
    | 用户余额记录
    |--------------------------------------------------------------------------
    */
    {
        path: '/user-money-records',
        name: 'user-money-records',
        meta: {

            title: '用户余额记录'
        },
        component: () => import('@/views/user-money-records/Index.vue')
    },

    /*
    |--------------------------------------------------------------------------
    | 用户提现管理
    |--------------------------------------------------------------------------
    */
    {
        path: '/user-withdraw',
        name: 'user-withdraw',
        meta: {

            title: '用户提现'
        },
        component: () => import('@/views/user-withdraw/Index.vue')
    },

    /*
    |--------------------------------------------------------------------------
    | 用户订单佣金
    |--------------------------------------------------------------------------
    */
    {
        path: '/user-order-commission',
        name: 'user-order-commission',
        meta: {

            title: '分销列表'
        },
        component: () => import('@/views/user-order-commission/Index.vue')
    },

    /*
    |--------------------------------------------------------------------------
    | 规则说明设置
    |--------------------------------------------------------------------------
    */
    {
        path: '/rule-explain',
        name: 'rule-explain',
        meta: {

            title: '规则说明设置'
        },
        component: () => import('@/views/rule-explain/Index.vue')
    },
    {
        path: '/rule-explain/create',
        name: 'rule-explain-create',
        meta: {

            title: '添加规则说明'
        },
        component: () => import('@/views/rule-explain/Form.vue')
    },
    {
        path: '/rule-explain/update/:id',
        name: 'rule-explain-update',
        meta: {

            title: '修改规则说明'
        },
        component: () => import('@/views/rule-explain/Form.vue')
    },
    {
        path: '/rule-explain/set/:id',
        name: 'rule-explain-set',
        meta: {

            title: '编辑规则说明'
        },
        component: () => import('@/views/rule-explain/Set.vue')
    },

    /*
    |--------------------------------------------------------------------------
    | 广告图设置
    |--------------------------------------------------------------------------
    */
    {
        path: '/ad',
        name: 'ad',
        meta: {

            title: '所有页面'
        },
        component: () => import('@/views/ad/Index.vue')
    },
    {
        path: '/ad/create',
        name: 'ad-create',
        meta: {

            title: '添加页面图'
        },
        component: () => import('@/views/ad/Form.vue')
    },
    {
        path: '/ad/update/:id',
        name: 'ad-update',
        meta: {

            title: '修改页面图'
        },
        component: () => import('@/views/ad/Form.vue')
    },
    {
        path: '/ad/set/:id',
        name: 'ad-set',
        meta: {

            title: '编辑页面图'
        },
        component: () => import('@/views/ad/Set.vue')
    },
    {
        path: '/ad/module/:module',
        name: 'ad-module',
        meta: {

            title: '首页设置'
        },
        component: () => import('@/views/ad/Index.vue')
    },
    {
        path: '/ad/share/:module',
        name: 'ad-share',
        meta: {

            title: '分享有礼'
        },
        component: () => import('@/views/ad/Index.vue')
    },
    {
        path: '/ad/brand/:module',
        name: 'ad-brand',
        meta: {

            title: '品牌专区'
        },
        component: () => import('@/views/ad/Index.vue')
    },
    {
        path: '/ad/credit/:module',
        name: 'ad-credit',
        meta: {

            title: '积分换好礼'
        },
        component: () => import('@/views/ad/Index.vue')
    },
    {
        path: '/ad/center/:module',
        name: 'ad-center',
        meta: {

            title: '个人中心'
        },
        component: () => import('@/views/ad/Index.vue')
    },

    /*
    |--------------------------------------------------------------------------
    | 微信物流助手
    |--------------------------------------------------------------------------
    */
    {
        path: '/express',
        name: '物流配送',
        meta: {

            title: '微信物流助手'
        },
        component: () => import('@/views/express/Index.vue')
    },
    {
        path: '/express/create',
        name: 'express-create',
        meta: {

            title: '添加物流公司'
        },
        component: () => import('@/views/express/Form.vue')
    },
    {
        path: '/express/update/:id',
        name: 'express-update',
        meta: {

            title: '修改物流公司'
        },
        component: () => import('@/views/express/Form.vue')
    },

    /*
    |--------------------------------------------------------------------------
    | 管理员
    |--------------------------------------------------------------------------
    */
    {
        path: '/admin',
        name: 'admin',
        meta: {

            title: '管理员设置'
        },
        component: () => import('@/views/admin/Index.vue')
    },
    {
        path: '/admin/create',
        name: 'admin-create',
        meta: {

            title: '添加管理员'
        },
        component: () => import('@/views/admin/Form.vue')
    },
    {
        path: '/admin/update/:id',
        name: 'admin-update',
        meta: {

            title: '修改管理员'
        },
        component: () => import('@/views/admin/Form.vue')
    },

    /*
    |--------------------------------------------------------------------------
    | 权限角色
    |--------------------------------------------------------------------------
    */
    {
        path: '/auth-role',
        name: 'auth-role',
        meta: {

            title: '权限角色设置'
        },
        component: () => import('@/views/auth-role/Index.vue')
    },
    {
        path: '/auth-role/create',
        name: 'auth-role-create',
        meta: {

            title: '添加权限角色'
        },
        component: () => import('@/views/auth-role/Form.vue')
    },
    {
        path: '/auth-role/update/:id',
        name: 'auth-role-update',
        meta: {

            title: '修改权限角色'
        },
        component: () => import('@/views/auth-role/Form.vue')
    },

    /*
    |--------------------------------------------------------------------------
    | 权限动作
    |--------------------------------------------------------------------------
    */
    {
        path: '/auth-action',
        name: 'auth-action',
        meta: {

            title: '权限动作设置'
        },
        component: () => import('@/views/auth-action/Index.vue')
    },
    {
        path: '/auth-action/create',
        name: 'auth-action-create',
        meta: {

            title: '添加权限动作'
        },
        component: () => import('@/views/auth-action/Form.vue')
    },
    {
        path: '/auth-action/update/:id',
        name: 'auth-action-update',
        meta: {

            title: '修改权限动作'
        },
        component: () => import('@/views/auth-action/Form.vue')
    },

    /*
    |--------------------------------------------------------------------------
    | 管理员操作日志
    |--------------------------------------------------------------------------
    */
    {
        path: '/admin-log',
        name: 'admin-log',
        meta: {
            title: '管理员操作日志'
        },
        component: () => import('@/views/admin-log/Index.vue')
    },

    /*
    |--------------------------------------------------------------------------
    | 配置项
    |--------------------------------------------------------------------------
    */
    {
        path: '/config',
        name: 'config',
        meta: {

            title: '配置项'
        },
        component: () => import('@/views/config/Index.vue')
    },
    {
        path: '/config/create',
        name: 'config-create',
        meta: {

            title: '添加配置项'
        },
        component: () => import('@/views/config/Form.vue')
    },
    {
        path: '/config/update/:id',
        name: 'config-update',
        meta: {

            title: '修改配置项'
        },
        component: () => import('@/views/config/Form.vue')
    },


    /*
    |--------------------------------------------------------------------------
    | 发货区域限制
    |--------------------------------------------------------------------------
    */
    {
        path: '/address-limit',
        name: 'address-limit',
        meta: {

            title: '发货区域限制设置'
        },
        component: () => import('@/views/address-limit/Index.vue')
    },
    {
        path: '/address-limit/create',
        name: 'address-limit-create',
        meta: {

            title: '添加限制发货区域'
        },
        component: () => import('@/views/address-limit/Form.vue')
    },

    /*
    |--------------------------------------------------------------------------
    | 会员权益设置
    |--------------------------------------------------------------------------
    */
    {
        path: '/member-rights',
        name: 'member-rights',
        meta: {

            title: '所有权益'
        },
        component: () => import('@/views/member-rights/Index.vue')
    },
    {
        path: '/member-rights/create',
        name: 'member-rights-create',
        meta: {

            title: '添加权益'
        },
        component: () => import('@/views/member-rights/Form.vue')
    },
    {
        path: '/member-rights/update/:id',
        name: 'member-rights-update',
        meta: {

            title: '修改权益'
        },
        component: () => import('@/views/member-rights/Form.vue')
    },
    {
        path: '/member-rights/bronze/:level',
        name: 'member-rights-bronze',
        meta: {

            title: '萌新铲屎官'
        },
        component: () => import('@/views/member-rights/Index.vue')
    },
    {
        path: '/member-rights/silver/:level',
        name: 'member-rights-silver',
        meta: {

            title: '进阶家长'
        },
        component: () => import('@/views/member-rights/Index.vue')
    },
    {
        path: '/member-rights/gold/:level',
        name: 'member-rights-gold',
        meta: {

            title: '资深主人'
        },
        component: () => import('@/views/member-rights/Index.vue')
    },
    {
        path: '/member-rights/platinum/:level',
        name: 'member-rights-bronze',
        meta: {

            title: '超级会员'
        },
        component: () => import('@/views/member-rights/Index.vue')
    },

    /*
    |--------------------------------------------------------------------------
    | 地址库管理
    |--------------------------------------------------------------------------
    */
    {
        path: '/biz-address',
        name: 'biz-address',
        meta: {

            title: '地址库管理'
        },
        component: () => import('@/views/biz-address/Index.vue')
    },
    {
        path: '/biz-address/create',
        name: 'biz-address-create',
        meta: {

            title: '添加地址库'
        },
        component: () => import('@/views/biz-address/Form.vue')
    },
    {
        path: '/biz-address/update/:id',
        name: 'biz-address-update',
        meta: {

            title: '修改地址库'
        },
        component: () => import('@/views/biz-address/Form.vue')
    },

    /*
   |--------------------------------------------------------------------------
   | 补单管理
   |--------------------------------------------------------------------------
   */
    {
        path: '/reissue',
        name: 'reissue',
        meta: {

            title: '补单数据'
        },
        component: () => import('@/views/reissue/Index.vue')
    },
    {
        path: '/reissue/create',
        name: 'reissue-create',
        meta: {

            title: '添加'
        },
        component: () => import('@/views/reissue/Form.vue')
    },
    {
        path: '/reissue/update/:id',
        name: 'reissue-update',
        meta: {

            title: '修改'
        },
        component: () => import('@/views/reissue/Form.vue')
    },

    /*
    |--------------------------------------------------------------------------
    | 宠物管理
    |--------------------------------------------------------------------------
    */
    {
        path: '/pet',
        name: 'pet',
        meta: {

            title: '宠物管理'
        },
        component: () => import('@/views/pet/Index.vue')
    },
    /*
    |--------------------------------------------------------------------------
    | 业务员管理
    |--------------------------------------------------------------------------
    */
    {
        path: '/salesperson',
        name: 'salesperson',
        meta: {
            title: '业务员管理'
        },
        component: () => import('@/views/salesperson/Index.vue')
    },

    {
        path: '/salesperson/create',
        name: 'salesperson-create',
        meta: {
            title: '业务员添加'
        },
        component: () => import('@/views/salesperson/Form.vue')
    },
    {
        path: '/salesperson/update/:id',
        name: 'salesperson-update',
        meta: {

            title: '业务员修改'
        },
        component: () => import('@/views/salesperson/Form.vue')
    },
]